<template>
  <div class="PageHeader">

    <div class="PageHeader-container">

      <div class="PageHeader-breadcrumbs">

        <icon class="PageHeader-lock"
          v-if="lock"
          name="lock"
          width="11px"
          height="11px" />

        <breadcrumbs class="PageHeader-breadcrumbs"
          v-if="breadcrumbs"
          :items="breadcrumbs" />

      </div>

      <share-button
        v-if="share">

        <share-tab />

      </share-button>

    </div>

  </div>
</template>

<script>
export default {
  name: 'PageHeader',

  props: {
    breadcrumbs: {
      type: Array
    },
    share: {
      type: [Boolean, Object],
      default: false
    },

    /**
     * Show lock icon before breadcrumbs
     */
    lock: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
@import 'properties';

.PageHeader {
  position: relative;
  z-index: 500;
  padding: 28px 0 14px;
  display: none;

  @media (min-width: 800px) and (min-height: 420px) {
    display: block;
  }
}

.PageHeader-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
}

.PageHeader-breadcrumbs {
  display: flex;
  align-items: center;
}

.PageHeader-lock {
  position: relative;
  top: -2px;
  margin-right: var(--unit-025);
}

.PageHeader-lock svg {
  fill: var(--c-grey-lt) !important;
}

.PageHeader-breadcrumbs {

}
</style>



// WEBPACK FOOTER //
// PageHeader.vue?64d5bacc